export const OPERATION_KIND_DEFINITION = 'OperationDefinition';
export const PERMISSIONS_ERROR = 'You do not have enough permissions';
export const SUBSCRIPTION_OPERATION_NAME  = 'subscription';
